module.exports = __webpack_public_path__ + "static/media/dartt.cf88da7f.png";